import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
import { toastWarning } from "../../utils/showApiErrorToast";

/**
 * Blocks non-admin users from admin-only routes (Tradar, System/Admin).
 */
export default function RequireAdmin({ children }: { children: React.ReactNode }) {
  const { isAdmin, isLoading } = useFeatureFlags();
  const history = useHistory();

  useEffect(() => {
    if (!isLoading && !isAdmin) {
      toastWarning("Access Denied", {
        description: "You don't have permission to access this page.",
      });
      history.push("/dashboard");
    }
  }, [isAdmin, isLoading, history]);

  if (!isLoading && !isAdmin) {
    return null;
  }

  return <>{children}</>;
}
